import { min } from "moment";
import React from "react";
import { Input, Message } from "semantic-ui-react";

const RenderInput = (props, { ...form }) => {
  return (
    <div style={{ marginBottom: 20, lineHeight: 40 }}>
      <Input
        onChange={props.onChange}
        placeholder={props.placeholder}
        type={props.type}
        fluid
        size="small"
        value={props.value}
        min={props.min}
        step={props.step}
        maxLength={props.maxLength}
        max={props.max}
        disabled={props.disabled}
        className={props.styles && "range_input"}
      />
      {props.isError && props.isTouched && (
        <Message visible error content={props.isError} />
      )}
    </div>
  );
};

export default RenderInput;
